import { render } from "./PicnicOutro2YogaView.vue?vue&type=template&id=6440bc9c&scoped=true"
import script from "./PicnicOutro2YogaView.vue?vue&type=script&lang=js"
export * from "./PicnicOutro2YogaView.vue?vue&type=script&lang=js"

import "./PicnicOutro2YogaView.vue?vue&type=style&index=0&id=6440bc9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6440bc9c"]])

export default __exports__